import wx from 'weixin-js-sdk'
import {getWxSign} from '@/http/api'

const jsApiList = ['updateAppMessageShareData', 'updateTimelineShareData', 'openLocation', 'scanQRCode']

class AuthWechat {
  signLink() {
    if (typeof window.entryUrl === 'undefined' || window.entryUrl === '') {
      window.entryUrl = document.location.href.split('#')[0]
    }
    return /(Android)/i.test(navigator.userAgent) ? document.location.href.split('#')[0] : window.entryUrl
  }

  // 当前是否是微信环境
  isWeixin() {
    return navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1
  }

  /**
   * 初始化wechat(分享配置)
   */
  wechat() {
    return new Promise((resolve, reject) => {
      let url = this.signLink()
      getWxSign({url}).then(res => {
        if (res.result === 'SUCCEED') {
          wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: res.data.appid, // 必填，公众号的唯一标识
            timestamp: res.data.timestamp, // 必填，生成签名的时间戳
            nonceStr: res.data.noncestr, // 必填，生成签名的随机串
            signature: res.data.sign, // 必填，签名
            jsApiList // 必填，需要使用的JS接口列表
          })

          wx.ready(result => {
            // 微信SDK准备就绪后执行的回调。
            resolve(wx, result)
          })
          wx.error(error => {
            reject(wx, error)
          })
        }
      })
    })
  }

  // 微信分享
  wxShare(shareObj) {
    this.wechat().then((wx, res) => {
      wx.ready(() => {
        wx.updateAppMessageShareData({
          title: shareObj.title, // 分享标题
          link: shareObj.link, // 分享链接
          desc: shareObj.desc, // 分享描述
          imgUrl: shareObj.imgUrl,
          success: function () {},
          cancel: function () {}
        })
        wx.updateTimelineShareData({
          title: shareObj.title, // 分享标题
          link: shareObj.link, // 分享链接
          desc: shareObj.desc, // 分享描述
          imgUrl: shareObj.imgUrl,
          success: function () {},
          cancel: function () {}
        })
      })
    })
  }

  // 使用微信内置地图查看位置接口
  openLocation(data) {
    return new Promise((resolve, reject) => {
      this.wechat().then((wx, res) => {
        this.toPromise(wx.openLocation, {
          latitude: data.latitude, // 纬度，浮点数，范围为90 ~ -90
          longitude: data.longitude, // 经度，浮点数，范围为180 ~ -180。
          name: data.name, // 位置名
          address: data.address, // 地址详情说明
          scale: data.scale, // 地图缩放级别,整型值,范围从1~28。默认为最大
          infoUrl: data.infoUrl || '' // 在查看位置界面底部显示的超链接,可点击跳转
        })
          .then(res => {
            resolve(res)
          })
          .catch(err => {
            reject(err)
          })
      })
    })
  }

  // 调起微信扫一扫接口
  scanQRCode() {
    return new Promise((resolve, reject) => {
      this.wechat().then((wx, res) => {
        this.toPromise(wx.scanQRCode, {
          needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
          scanType: ['qrCode']
        })
          .then(res => {
            resolve(res)
          })
          .catch(err => {
            reject(err)
          })
      })
    })
  }

  toPromise(fn, config = {}) {
    return new Promise((resolve, reject) => {
      fn({
        ...config,
        success(res) {
          resolve(res)
        },
        fail(err) {
          reject(err)
        },
        complete(err) {
          reject(err)
        },
        cancel(err) {
          reject(err)
        }
      })
    })
  }
}

export default new AuthWechat()
